import {UIGameActionButtonMultiView} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonMultiView'

export class UIWGameActionButtonMultiView extends UIGameActionButtonMultiView {
    protected repositionButtons() {
        this.expandedButtons.sort((a, b) => a.preferredPosition > b.preferredPosition ? 1 : -1)
        const canvas = this.uiGameManager.canvasController
        const numberOfButtons = this.expandedButtons.length
        const buttonShiftValue = (numberOfButtons + 1) / 2
        const spacingBetweenButtons = canvas.itemSize
        const y = this.y - canvas.itemSize
        const padding = canvas.margin

        let position = 1
        for(const button of this.expandedButtons) {
            const x = this.x + (position - buttonShiftValue) * spacingBetweenButtons
            button.x = x
            button.y = y
            button.width = canvas.itemSize - (padding * 2)
            button.height = canvas.itemSize - (padding * 2)

            position += 1
        }
    }
}
